import {Stack, Typography} from '@mui/material'
import {Dispatch, SetStateAction} from 'react'
import {useTranslation} from 'react-i18next'

import {useConnectedSignals} from '../../../hooks'
import {useKilnConfig} from '../../../providers'
import {SignalsModalData} from '../../../types'
import {ConnectSignalsButton} from '../ConnectSignalsButton'

interface KilnShellSignalsButtonProps {
  disabledSignals: string[]
  setSignalsModalData: Dispatch<SetStateAction<SignalsModalData | undefined>>
}

export const KilnShellSignalsButton: React.FC<KilnShellSignalsButtonProps> = ({
  disabledSignals,
  setSignalsModalData
}) => {
  const {t} = useTranslation()
  const {kilnLayout} = useKilnConfig()

  const connectedSignals = useConnectedSignals({
    selectedSignals: kilnLayout.selectedSignals,
    kilnPartId: kilnLayout.kilnShell.id
  })

  return (
    <Stack spacing={0.5}>
      <Typography variant="caption">{t('kilnConfig.generalKiln')}</Typography>
      <ConnectSignalsButton
        testId={'general-signals-btn'}
        connectedSignals={connectedSignals.length}
        onClick={() =>
          setSignalsModalData({
            type: 'kiln-shell',
            layout: kilnLayout.kilnShell,
            disabledSignals
          })
        }
        ButtonProps={{style: {height: '48px'}}}
      />
    </Stack>
  )
}
